import { render, staticRenderFns } from "./OrderProofReview.vue?vue&type=template&id=43203eac"
import script from "./OrderProofReview.vue?vue&type=script&lang=js"
export * from "./OrderProofReview.vue?vue&type=script&lang=js"
import style0 from "./OrderProofReview.vue?vue&type=style&index=0&id=43203eac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports